// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"half-screen-slider-module__wrapper__2r-kp","container":"half-screen-slider-module__container__1Ct3u"};